import React from 'react';

import './WidgetEdit.css'
import HeroHeaderEditNEO from './WidgetEditTypes/HeroHeaderEditNEO';
import HiWidgetEdit from './WidgetEditTypes/HiWidgetEdit';
import VideoTeaserEdit from './WidgetEditTypes/VideoTeaserEdit';
import SimplisticHeaderEdit from './WidgetEditTypes/SimplisticHeaderEdit';
import SupremeTestimonialEdit from './WidgetEditTypes/SupremeTestimonialEdit';
import SimplisticQuoteEdit from './WidgetEditTypes/SimplisticQuoteEdit';
import MethodologyWidgetEdit from './WidgetEditTypes/MethodologyWidgetEdit';
import PersonalBrandingWidgetEdit from './WidgetEditTypes/PersonalBrandingWidgetEdit';
import SimplisticTestimonialEdit from './WidgetEditTypes/SimplisticTestimonialEdit';
import SimplisticServicesEdit from './WidgetEditTypes/SimplisticServicesEdit';
import BulletPointsWidgetEdit from './WidgetEditTypes/BulletPointsWidgetEdit';
import ComparisonWidgetEdit from './WidgetEditTypes/ComparisonWidgetEdit';
import ProductInfoWidgetEdit from './WidgetEditTypes/ProductInfoWidgetEdit';
import ProductFormPopupEdit from './WidgetEditTypes/ProductFormPopupEdit';
import EventInfoWidgetEdit from './WidgetEditTypes/EventInfoWidgetEdit';
import CourseInfoWidgetEdit from './WidgetEditTypes/CourseInfoWidgetEdit';
import InfiniteBannerEdit from './WidgetEditTypes/InfiniteBannerEdit';
import QAWidgetEdit from './WidgetEditTypes/QAWidgetEdit';
import HolisticTestimonialEdit from './WidgetEditTypes/HolisticTestimonialEdit';
import BragBarEdit from './WidgetEditTypes/BragBarEdit';
import SpiritualFeatureBannerEdit from './WidgetEditTypes/SpiritualFeatureBannerEdit';
import FancyFooterEdit from './WidgetEditTypes/FancyFooterEdit';
import AchievementsBannerEdit from './WidgetEditTypes/AchievementsBannerEdit';
import SpiritualQuoteCardEdit from './WidgetEditTypes/SpiritualQuoteCardEdit';
import GalleryWidgetEdit from './WidgetEditTypes/GalleryWidgetEdit';

function WidgetEdit({ selectedWidget, onUpdateWidget, colors, pageData }) {
  const widgetEditorClass = selectedWidget ? "widget-editor active-widget" : "widget-editor";

  
  const renderEditOptions = (widget) => {
    switch (widget.type) {
           case 'HeroHeader':
            return <HeroHeaderEditNEO key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'HiWidget':
            return <HiWidgetEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'VideoTeaser':
            return <VideoTeaserEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'SimplisticHeader':
            return <SimplisticHeaderEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'SupremeTestimonial':
            return <SupremeTestimonialEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'SimplisticQuote':
            return <SimplisticQuoteEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'MethodologyWidget':
            return <MethodologyWidgetEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'PersonalBrandingWidget':
            return <PersonalBrandingWidgetEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'SimplisticTestimonial':
            return <SimplisticTestimonialEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'SimplisticServices':
            return <SimplisticServicesEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'BulletPointsWidget':
            return <BulletPointsWidgetEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'ComparisonWidget':
            return <ComparisonWidgetEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'ProductInfoWidget':
            return <ProductInfoWidgetEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'EventInfoWidget':
            return <EventInfoWidgetEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'CourseInfoWidget':
            return <CourseInfoWidgetEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'InfiniteBanner':
            return <InfiniteBannerEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'QAWidget':
            return <QAWidgetEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'HolisticTestimonial':
            return <HolisticTestimonialEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'BragBar':
            return <BragBarEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'SpiritualFeatureBanner':
            return <SpiritualFeatureBannerEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'FancyFooter':
            return <FancyFooterEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} pageData={pageData} />;
          case 'AchievementsBanner':
            return <AchievementsBannerEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'SpiritualQuoteCard':
            return <SpiritualQuoteCardEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
          case 'GalleryWidget':
            return <GalleryWidgetEdit key={widget.id} widget={widget} onUpdate={onUpdateWidget} colors={colors} />;
    
                  default:
        return <div>Widget-Typ nicht unterstützt</div>;
    }
  };

  return (
    <div className={widgetEditorClass}>
      {selectedWidget && renderEditOptions(selectedWidget)}
    </div>
  );
}

export default WidgetEdit;
